import React, { useContext} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { GlobalTheme } from '../../layouts/theme';
import { Theme } from '../contexts/themeContext.js';

const useStyles = makeStyles(theme => ({
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
}));

export default function ContentDialog(props) {
    const classes = useStyles();
    const { theme } = useContext(Theme);
    const currentTheme = theme ? (GlobalTheme[theme]) : (GlobalTheme[localStorage.getItem("theme")]);

    return (
        <div>
            <Dialog
                open={props.open}
                onClose={props.close}
                fullWidth={true}
                maxWidth={props.maxWidth}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                id="content-dialog"
            >
                <DialogTitle id="alert-dialog-title" style={props?.styleTitle}>
                    {props.title}
                    {props.close ? (
                        <IconButton aria-label="Close" className={classes.closeButton}  onClick={props.close}>
                            <CloseIcon />
                        </IconButton>
                    ) : null}
                </DialogTitle>
                <DialogContent>
                    {props.children}
                </DialogContent>
                {
                    !props.noActions &&
                    <DialogActions>
                        {
                            !props.hideAllConfirm
                            &&
                            <>
                                {
                                    !props.hideConfirm && !props.disableWithStyle && <Button onClick={props.onConfirm} variant="contained" style={{ background: currentTheme.secondary, color: 'white' }}>{props.confirmName || 'Save'}</Button>
                                }

                                {
                                    props.disableWithStyle && <Button variant="contained" color="default">{props.confirmName || 'Save'}</Button>
                                }
                            </>
                        }

                        <Button onClick={props.close} variant="contained" color="default" autoFocus>{props.closeName || 'Cancel'}</Button>
                    </DialogActions>
                }
                
            </Dialog>
        </div>
    );
}
